// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;The sceptre of wickedness shall not hold sway<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;over the land allotted to the righteous,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;lest the righteous turn their hands to evil.<br> </p> </div></div>";
// Exports
module.exports = code;